export default __webpack_public_path__ + "static/media/loginLogo.68c5270b.png";